import { app } from '../../app.module'
// Lineアカウントデータのインタフェース
interface ILineAccountData {
  followers: number
  likes: number
  comments: number
  shares: number
  engagements: number
  engagementRate: number
  posts: number
}

/**
 * Lineアカウントテーブルの平均
 * @class AccountLineTableAverageComponentCtrl
 */
class AccountLineTableAverageComponentCtrl {
  // アカウント一覧
  private sortAccounts: ILineAccountData[]
  // 1投稿あたりの平均フラグ
  private averagePerPost: boolean
  // 平均データ
  private averageData: ILineAccountData

  constructor() {
    this.averagePerPost = true
    this.averageData = {
      followers: 0,
      likes: 0,
      comments: 0,
      shares: 0,
      engagements: 0,
      engagementRate: 0,
      posts: 0,
    }
  }

  /**
   * アカウント一覧が変更されるまたは1投稿あたりの平均フラグが変更される時、平均を算出
   */
  public $onChanges(): void {
    this.caculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private caculateAverage(): void {
    if (this.sortAccounts === undefined) {
      this.sortAccounts = []
    }
    this.averageData = {
      followers: 0,
      likes: 0,
      comments: 0,
      shares: 0,
      engagements: 0,
      engagementRate: 0,
      posts: 0,
    }
    if (this.sortAccounts.length === 0) {
      return
    }

    // 合計する
    this.sortAccounts.forEach((account) => {
      this.averageData.followers = this.averageData.followers + account.followers
      this.averageData.posts = this.averageData.posts + account.posts
      this.averageData.engagementRate = this.averageData.engagementRate + account.engagementRate
      // 1投稿あたりの平均の場合
      if (this.averagePerPost === true && account.posts > 0) {
        this.averageData.likes = this.averageData.likes + account.likes / account.posts
        this.averageData.comments = this.averageData.comments + account.comments / account.posts
        this.averageData.shares = this.averageData.shares + account.shares / account.posts
        this.averageData.engagements =
          this.averageData.engagements + account.engagements / account.posts
      } else {
        // 1投稿あたりの平均ではないの場合
        this.averageData.likes = this.averageData.likes + account.likes
        this.averageData.comments = this.averageData.comments + account.comments
        this.averageData.shares = this.averageData.shares + account.shares
        this.averageData.engagements = this.averageData.engagements + account.engagements
      }
    })

    // 平均する
    const sortAccountLength = this.sortAccounts.length

    this.averageData.followers = this.averageData.followers / sortAccountLength
    this.averageData.likes = this.averageData.likes / sortAccountLength
    this.averageData.comments = this.averageData.comments / sortAccountLength
    this.averageData.shares = this.averageData.shares / sortAccountLength
    this.averageData.engagements = this.averageData.engagements / sortAccountLength
    this.averageData.engagementRate = this.averageData.engagementRate / sortAccountLength
    this.averageData.posts = this.averageData.posts / sortAccountLength
  }
}

app.component('accountLineTableAverage', {
  bindings: {
    sortAccounts: '<',
    averagePerPost: '<',
  },
  template: require('./account-line-table-average.pug')(),
  controller: AccountLineTableAverageComponentCtrl,
})
